<ng-container *ngIf="Asn else preloading">
  <h1 *header="Asn + ' Training'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>

  <ng-container *ngIf="(Training$ | async) as Training else loading">
    <form (ngSubmit)="Submit()" [formGroup]="form">
      <ng-container #msg></ng-container>
      <ng-container *ngIf="Level === 'Professional'">
        <h2>{{ Type }} State Licenses or Credentials</h2>
        <p><strong>Please select the states you practice in.</strong> If licensing is required by your state, you will
          be asked for your license number.</p>
        <p>If your state requires a license, but you are exempt based on your type of practice, please check &quot;I am
          exempt from state licensing.&quot; If you don’t know your license details, <a
            [href]="'/state-license-credentials'" [appColorbox]="{ width: 800, height: 600 }">find
            them on your state board's website</a>, then fill them in below. Please note that if you are not in
          compliance with your state requirements, your professional liability insurance may not be valid.</p>
      </ng-container>
      <app-training-validation-errors [Asn]="Asn" [Level]="Level" [parentGroup]="form"></app-training-validation-errors>
      <div class="row">
        <h3 bsMigration class="col-xs-12"><img [src]="Logo" [alt]="Title"> {{ Title }}</h3>
      </div>
      <ng-container *ngIf="Level === 'Professional'">
        <div class="row">
          <div class="col-sm-6">
            <fieldset bsMigration [bs3Class]="['panel-primary']" class="panel">
              <div bsMigration [bs4Class]="['bg-primary', 'text-light']" class="panel-heading">Primary</div>
              <div bsMigration class="panel-body">
                <app-license [parentGroup]="form" groupName="License1" [license]="Training.License1" [Asn]="Asn">
                </app-license>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6">
            <fieldset bsMigration class="panel panel-info">
              <div bsMigration class="panel-heading">Secondary</div>
              <div bsMigration class="panel-body">
                <app-license [parentGroup]="form" groupName="License2" [license]="Training.License2" [Asn]="Asn">
                </app-license>
              </div>
            </fieldset>
          </div>
        </div>
        <p><span class="text-danger">*</span> = required field</p>
      </ng-container>
      <app-school [training]="Training" [parentGroup]="form" [SchoolType]="Type" [PreviousRecord]="PreviousRecord"
        [Selection]="Selection"></app-school>
      <p><span class="text-danger">*</span> = required field</p>
      <p *ngIf="!group">
        <button class="btn btn-primary" [disabled]="form.invalid" type="submit">Next</button>
      </p>
    </form>
  </ng-container>
</ng-container>

<ng-template #loading>
  <ng-container #msg>
    <p><br /><br /><strong>Loading...</strong><br /><br /></p>
  </ng-container>
</ng-template>

<ng-template #preloading>
  <h1 *header="'License & Training'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>
  <p><br /><br /><strong>Loading...</strong><br /><br /></p>
</ng-template>
